module.exports = __webpack_public_path__ + "img/edit.94b36c6a.svg";